import CheckIcon from '@mui/icons-material/Check'
import { Box, ToggleButton, Toolbar, Typography } from '@mui/material'
import { useState } from 'react'

interface IExecutionOptionsToolbar {
  handleOptions: () => void
}

const UUIDToggle = ({ handleOptions }: IExecutionOptionsToolbar) => {
  const [selected, setSelected] = useState(false)

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        verticalAlign: 'middle',
        width: '100%',
        maxWidth: '90vw',
        flexWrap: 'wrap',
        gap: '1rem',
        pb: '0rem',
        pl: '1.5rem'
      }}>
      <Typography variant="subtitle1">Mostrar UUID</Typography>
      <ToggleButton
        size="small"
        value="check"
        selected={selected}
        onChange={() => {
          setSelected(!selected)
          handleOptions()
        }}>
        <CheckIcon />
      </ToggleButton>
    </Box>
  )
}

export const ExecutionOptionsToolbar = ({ handleOptions }: IExecutionOptionsToolbar) => {
  return (
    <Toolbar
      sx={{
        width: '100%',
        p: '0px !important',
        mb: '15px'
      }}>
      <UUIDToggle handleOptions={() => handleOptions()}></UUIDToggle>
    </Toolbar>
  )
}
